import {Card,Col,Image,Row,Modal} from "react-bootstrap";
import {Link,useLocation} from "react-router-dom";
import Room from "./room";
import React, {useEffect, useState} from "react";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

    const Home = ()=>{
        const [checked,setChecked] = useState(false);
        let query = useQuery();
        const [show, setShow] = useState(false);

        useEffect(()=>{
            let qr = localStorage.getItem('qr');
            if(qr){
                let [roomID,time] = qr.split(',');
                document.location.href=`/booking/booking/${roomID}?t=${time}`;
                localStorage.removeItem('qr');
            }
        },[])

        return (
            <>
                <Row className="mt-4 mb-4">
                    <Col md={1}></Col>
                    <Col>
                        <Card>
                            <Card.Header>
                                <h4><b>หลักเกณฑ์การใช้ห้อง Smart Classroom & Studio</b></h4>
                            </Card.Header>
                            <Card.Body>
                                <ol>
                                    <li>การใช้ห้องต้องเป็นการประชุม การอบรม การเรียนการสอน บันทึกการสอน หรือกิจกรรมที่มีส่วนร่วมในการส่งเสริมและเผยแพร่ภาพลักษณ์ของมหาวิทยาลัย หรือกิจกรรมอื่นๆ ที่ไม่ขัดต่อกฎหมายและระเบียบของทางราชการ ตลอดจนศีลธรรมอันดีงามและความสงบเรียบร้อยของสังคม</li>
                                    <li>ผู้มีสิทธิ์ในการขอใช้บริการห้องของมหาวิทยาลัยขอนแก่น ได้แก่ คณาจารย์ บุคลากร และนักศึกษา มหาวิทยาลัยขอนแก่น</li>
                                    {/*<li>ผู้ขอใช้บริการต้องปฏิบัติตามหลักเกณฑ์การใช้ห้องอย่างเคร่งครัด</li>*/}
                                    <li>ผู้ใช้บริการสามารถขอจองห้องได้ที่ระบบ LTIC Booking <span style={{color:"red"}}>โดยจองห้องล่วงหน้าอย่างน้อย 2 วันทําการ</span></li>
                                    <li>หากต้องการจองห้องสำหรับใช้งานติดต่อกันหลายวัน เช่น ประชุมวิชาการ อบรม เป็นต้น <span style={{color:"red"}}>ให้ติดต่อล่วงหน้าที่ Email : ltic.psli@kku.ac.th</span></li>
                                    {/*<li>ในกรณีมีการใช้นอกเวลาราชการ ผู้ขอใช้บริการเป็นผู้รับผิดชอบค่าล่วงเวลาตามระเบียบการเบิกจ่ายเงินตอบแทนการปฏิบัติงานนอกเวลาราชการมหาวิทยาลัยขอนแก่น</li>*/}
                                    {/*<li>ศูนย์นวัตกรรมการเรียนการสอนฯ ขอสงวนสิทธิ์ในการพิจารณาให้ใช้บริการสถานที่เป็นรายกรณี</li>*/}
                                    <li>หากต้องการ <span style={{color:"red"}}>ยกเลิกการจองห้อง</span> ผู้ใช้บริการสามารถคลิกยกเลิกการจองของท่านได้ด้วยตนเองที่ระบบ LTIC Booking</li>
                                    <li>ผู้ใช้บริการต้องผ่านการแนะนําวิธีการใช้งานอุปกรณ์ต่างๆ ภายในห้องจากผู้ดูแลห้องก่อนการใช้งานจริง</li>
                                    {/*<li>การเปิดระบบปรับอากาศจะเปิดก่อนการใช้งาน ประมาณ 30 นาที</li>*/}
                                    <li>ห้ามนําอาหารและเครื่องดื่มเข้ามาภายในห้องโดยเด็ดขาด</li>
                                    <li>สําหรับการบันทึกการสอน จะมีการจัดเก็บไฟล์บันทึกเป็นระยะเวลา 1 สัปดาห์เท่านั้น</li>
                                    <li>ในกรณีที่เกิดความเสียหายแก่สถานที่และอุปกรณ์จากการใช้งาน ผู้ใช้บริการต้องชดใช้ค่าเสียหายตามความเป็นจริง</li>
                                    <li>ผู้ใช้บริการต้องตรวจสอบสิ่งของมีค่าก่อนออกจากห้อง ทางศูนย์นวัตกรรมการเรียนการสอนฯ ไม่รับผิดชอบต่อสิ่งของมีค่าที่สูญหายทุกกรณี</li>
                                    <li>ผู้ใช้บริการต้องรอการตรวจเช็คอุปกรณ์ภายในห้องจากเจ้าหน้าที่หลังการใช้งาน เพื่อตรวจสอบความเสียหายทุกครั้ง</li>
                                    <li>ขอความร่วมมือผู้ใช้บริการประเมินความพึงพอใจทุกครั้งหลังจากการใช้งาน เพื่อนําข้อมูลไปปรับปรุงพัฒนาให้ดียิ่งขึ้น >>
                                        <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSf3flRtxUecSQtjF8oJhXfy2fcNtz0XnxdjoKv6C6om91K2yg/viewform?usp=send_form" target="_blank"> คลิกทำแบบประเมิน</a></li>
                                </ol>
                            </Card.Body>
                            <Card.Footer>
                                <div className="form-check text-right">
                                    <input className="form-check-input" type="checkbox" id="gridCheck1" onChange={e=>{
                                        let chk = e.target.checked;
                                        setChecked(chk);
                                    }}/>
                                    <label className="form-check-label" htmlFor="gridCheck1">
                                        ยอมรับหลักเกณฑ์การใช้งาน
                                    </label>
                                </div>
                                {checked &&
                                    <div className="text-right">
                                        <Link to="/room" className="btn btn-primary">ตกลง</Link>
                                    </div>
                                }
                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col md={1}></Col>
                </Row>
                <Modal size='lg' show={show} onHide={()=>{
                 setShow(false);
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>ประกาศ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <img src='/booking/post2.jpg' width="100%" alt={'Post 1'}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={()=>{
                            setShow(false);
                        }}>Close</button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
export default Home;
